import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type GetWorkflowRuleFieldOutputOptionsQueryVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type GetWorkflowRuleFieldOutputOptionsQueryResult = { __typename?: 'Query' } & {
  workflowRuleFieldOutputOptions: Array<
    { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'component' | 'label' | 'name'>
  >;
};

export const GetWorkflowRuleFieldOutputOptionsDocument = /*#__PURE__*/ gql`
  query getWorkflowRuleFieldOutputOptions {
    workflowRuleFieldOutputOptions {
      component
      label
      name
    }
  }
`;

/**
 * __useGetWorkflowRuleFieldOutputOptionsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowRuleFieldOutputOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowRuleFieldOutputOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowRuleFieldOutputOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowRuleFieldOutputOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWorkflowRuleFieldOutputOptionsQueryResult,
    GetWorkflowRuleFieldOutputOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<GetWorkflowRuleFieldOutputOptionsQueryResult, GetWorkflowRuleFieldOutputOptionsQueryVariables>(
    GetWorkflowRuleFieldOutputOptionsDocument,
    options
  );
}
export function useGetWorkflowRuleFieldOutputOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowRuleFieldOutputOptionsQueryResult,
    GetWorkflowRuleFieldOutputOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<GetWorkflowRuleFieldOutputOptionsQueryResult, GetWorkflowRuleFieldOutputOptionsQueryVariables>(
    GetWorkflowRuleFieldOutputOptionsDocument,
    options
  );
}
export type GetWorkflowRuleFieldOutputOptionsQueryHookResult = ReturnType<typeof useGetWorkflowRuleFieldOutputOptionsQuery>;
export type GetWorkflowRuleFieldOutputOptionsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowRuleFieldOutputOptionsLazyQuery
>;
